<ngx-spinner type="ball-clip-rotate"></ngx-spinner>
<ng-container *ngIf="initialized">
  <div *ngIf="page === 'login'">
    <app-lasuite-login></app-lasuite-login>
  </div>

  <div *ngIf="page === 'register'">
    <app-lasuite-register></app-lasuite-register>
  </div>

  <div *ngIf="page === 'forgot-password'">
    <app-lasuite-forgot-password></app-lasuite-forgot-password>
  </div>

  <!-- 送信しましたページ -->
  <div *ngIf="page === 'password-reset-send'">
    <app-lasuite-change-password-sent></app-lasuite-change-password-sent>
  </div>

  <app-lasuite-register-resend
    *ngIf="page === 'register-resend'"
  ></app-lasuite-register-resend>
</ng-container>
